import { IRowNode } from '@ag-grid-community/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subject } from 'rxjs';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { GetBatchPayload } from 'src/app/models/fbmOrders.model';
import { AgGridRequestService } from 'src/app/services/ag-grid-request.service';


import { FilterDefinition } from '../planyard/purchase-orders/po-filter-dropdown/filters.model';

@Injectable({
  providedIn: 'root'
})
export class FbmOrdersService implements OnDestroy {
  printFbmLabel:any[]=[];
  printPackingLabel:any[]=[];
  batchFilter: Subject<Array<FilterDefinition>> = new Subject<Array<FilterDefinition>>();
  batchTabAction: Subject<string> = new Subject<string>();
  isSubmitForm: Subject<boolean> = new Subject<boolean>();
  displayedProductModal: Subject<IRowNode> = new Subject<IRowNode>();
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  baseurl = "api/PickingBatchs/";
  selectableUsers: any;
  isDisabaleSubmit: BehaviorSubject<any> = new BehaviorSubject(null);
  private destroy$ = new Subject<void>();

  constructor(private http: HttpClient,
    private agGridRequestService: AgGridRequestService,
    private snackBar: MatSnackBar) { }

  getFbmOrderList(body: any, columnDefs: any, globalSearch: string, account?: string) {
    const payload = this.agGridRequestService
      .transformAgGridRequest(body, columnDefs, globalSearch);

    return this.http.post(
      `${this.baseurl}GetFBMOrdersList`,
      this.transformAgGridSortModel(payload),
      this.options);
  }
  getBatches(status: string, startRow: number, endRow: number, filterObj: GetBatchPayload = {} as GetBatchPayload) {
    return this.http.post(
      `${this.baseurl}GetBatchsList`,
      { status, startRow, endRow, ...filterObj },
      this.options);
  }

  saveBatches(data: any) {
    return this.http.post(
      `${this.baseurl}SaveBatchs`,
      data,
      this.options);
  }
  getFbmOrdersSummary(data: any) {
    return this.http.post(
      `${this.baseurl}GetFBMOrdersSummaries`,
      data,
      this.options);
  }
  getFBMOrdersFilterSummaries(body: any, globalSearch: string, filterSearch: string,columnDefs: any,) {
    const payload = this.agGridRequestService
      .transformAgGridRequest(body, columnDefs, globalSearch);
    return this.http.post(
      `${this.baseurl}GetFBMOrdersFilterSummaries`,
      {...this.transformAgGridSortModel(payload),filterSearch},
      this.options
    );
  }

  getPickBatchDetails(data: any) {
    return this.http.post(
      `${this.baseurl}GetPickingItemByBatch`,
      data,
      this.options);
  }
  getPickBatchDetailsItem(data: any) {
    return this.http.post(
      `${this.baseurl}GetPickingOrderByLocation`,
      data,
      this.options);
  }
  getShipBatchByBatchesId(body: any, batchsId, globalSearch: string) {
    return this.http.post(
      `${this.baseurl}GetShipBatchByBatchesId`,
      { ...body, globalSearch, batchsId },
      this.options
    );
  }
  getShipOrderDetailsByIdAndOrderId(body: any, ordersId: any, globalSearch: string, batchsId: any) {
    return this.http.post(
      `${this.baseurl}GetShipOrderDetailsByIdAndOrderId`,
      { ...body, batchsId, ordersId, globalSearch },
      this.options
    );
  }

  markasPicked(batchsIds: Array<number>, status: string) {
    return this.http.post(
      `${this.baseurl}MarkasPicked`,
      { batchsIds, status },
      this.options
    );
  }

  margeasBatch(batchsIds: Array<number>) {
    return this.http.post(
      `${this.baseurl}MargeAsBatch`,
      { batchsIds },
      this.options
    );
  }


  printActionPickList(batchsIds: Array<number>) {
    return this.http.post(
      `${this.baseurl}PrintFBMActionPickList`,
      { batchsIds },
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      });
  }
  removeFromBatch(batchsId: number, orderids: string[]) {
    return this.http.post(
      `${this.baseurl}RemoveFromBatch`,
      { batchsId, orderids }, this.options);
  }

  markasShipped(orderids: string[], batchsId: number) {
    return this.http.post(
      `${this.baseurl}MarkasShipped`,
      { orderids, batchsId },
      this.options
    );
  }

  getFinancialDetails(orderId: string) {
    return this.http.post(`${this.baseurl}GetFinancialDetailsByOrderId`, { orderId }, this.options);
  }
  
  GetWagon() {
    return this.http.get(`${this.baseurl}GetWagonList`, this.options);
  }

  createPickingBatch(payload) {
    return this.http.post(`${this.baseurl}CreatePickingBatch`,payload,this.options);
  }

  addOrdersToBatch(payload) {
    return this.http.post(`${this.baseurl}AddOrdersToBatch`,payload,this.options);
  }

  SaveUpdateWagon(payload) {
    return this.http.post(`${this.baseurl}SaveUpdateWagon`, payload, this.options);
  }

  RemoveWagon(payload) {
    return this.http.post(`${this.baseurl}RemoveWagon`, payload, this.options);
  }
  
  printPickList(data: any) {

    return this.http.post(
      `${this.baseurl}PrintFBMPickList`,
      { ...data },
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      });
  }

  getWagonList() {
    return this.http.get(
      `/${this.baseurl}/GetWagonList`,
      this.options
    );
  }
  savePickingItems(payload) {
    return this.http.post(
      `${this.baseurl}SavePickingItems`, payload,
      this.options);
  }

  updateBatchWagon(payload){
    return this.http.post(
      `${this.baseurl}UpdateBatchWagon`,payload,this.options);
  }

  getBatchDetailById(payload) {
    return this.http.post(`${this.baseurl}GetBatchDetailById`,payload, this.options);
  }

  transformAgGridSortModel(body: any) {
    if (body.sortModel.length) {
      body.sortModel.map((x: any) => {
        x.colId = this.convertColId(x.colId);
        return x;
      });
    }
    let keys = Object.keys(body.filterModel);
    if (keys.length) {
      body.filterModel = keys.reduce((obj, current) => {
        let keyName = this.convertColId(current);
        obj[keyName] = body.filterModel[current];
        return obj;
      }, {});
    }
    return body;
  }

  convertColId(colId: string) {
    switch (colId) {
      case "productDetailsList":
        return "SKU";
      case "ShipDate":
        return "shipByDate";
      case "CurrencyType":
        return "Currency";
      default:
        return colId;
    }
  }

  showSuccessMessage(message: string): void {
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 9000,
        horizontalPosition: 'center',
        data: {
          title: message,
          action: 'Dismiss',
          type: 'success',
        },
      });
  }

  showErrorMessage(message: string): void {
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 9000,
        horizontalPosition: 'center',
        data: {
          title: message,
          action: 'Dismiss',
          type: 'error',
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
